export const lessonCategoriesSelector = (state: any) => state.lessonCategories;
